import { KyInstance } from 'ky';

// @FIXME: rafactor to use object on classes
export class APIContainer {
    private services: Map<string, InstanceType<Constructor>> = new Map();

    constructor(private readonly apiClient: KyInstance) {
        this.apiClient = apiClient;
    }

    // @NOTE: consider to use inversify or other DI container
    register<T>(name: string, Service: Constructor<T>): void {
        const instance = new Service(this.apiClient);

        this.services.set(name, instance);
    }

    get<T>(name: string): T {
        const service = this.services.get(name);

        if (!service) {
            throw new Error(`Service ${name} not found`);
        }

        return service as T;
    }
}
